import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    text: 'Llevaba 2 años con diabetes y nunca nadie me explicó las cosas tan claro. En una semana ya sabía exactamente qué cocinar. Mi glucosa bajó 40 puntos en el primer mes.',
    author: 'María G.',
    detail: '54 años, diagnosticada hace 2 años'
  }, {
    text: 'Lo mejor es el plan de menús. Yo no tengo tiempo para pensar qué cocinar y esto me resolvió la vida. Mi familia come lo mismo que yo y les encanta.',
    author: 'Roberto L.',
    detail: '61 años'
  }, {
    text: 'Pensé que era otro PDF más. Pero cuando vi la organización, las recetas y la comunidad, entendí que esto es diferente. Ojalá lo hubiera encontrado antes.',
    author: 'Carmen S.',
    detail: '47 años'
  }, {
    text: 'La guía de restaurantes me cambió la vida social. Antes rechazaba todas las invitaciones. Ahora salgo, disfruto y sé exactamente qué pedir.',
    author: 'Jorge M.',
    detail: '58 años'
  }];
  return <section className="py-20 px-4 bg-[#E6F4EA]/30" data-id="element-235">
      <div className="max-w-7xl mx-auto" data-id="element-236">
        <div className="text-center mb-16" data-id="element-237">
          <span className="text-[#1B4332] font-semibold tracking-wide uppercase text-sm" data-id="element-238">
            Lo que dicen quienes ya lo tienen
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mt-3" data-id="element-239">
            Más de 2,000 Personas Ya Transformaron Su Relación Con la Comida
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-240">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-[#1B4332]/5 flex flex-col" data-id="element-241">
              <div className="flex gap-1 mb-4" data-id="element-242">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#D97706] text-[#D97706]" data-id="element-243" />)}
              </div>
              <p className="text-[#1C1917]/80 italic mb-6 flex-grow" data-id="element-244">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-245">
                <p className="font-bold text-[#1B4332]" data-id="element-246">{t.author}</p>
                <p className="text-xs text-gray-500" data-id="element-247">{t.detail}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}